const sv = {
  title: 'Skapa din App',
  description:
    'Bygg din app på Convex SaaS, utforska dokumentationen och påbörja din resa.',
  nav: {
    dashboard: 'Instrumentpanel',
    jobs: 'Tjänster',
    candidates: 'Kandidater',
    questionBank: 'Frågebank',
    templates: 'Mallar',
    settings: 'Inställningar',
    billing: 'Fakturering',
    documentation: 'Dokumentation',
    personalAccount: 'Personligt konto',
    topUpBalance: 'Fyll på saldo',
    theme: 'Tema',
    language: 'Språk',
    logOut: 'Logga ut',
  },
  header: {
    dashboard: {
      title: 'Instrumentpanel',
      description: 'Hantera dina appar och se din användning.',
    },
    jobs: {
      title: 'Tjänster',
      description: 'Hantera dina jobbannonser och intervjumallar.',
    },
    settings: {
      title: 'Inställningar',
      description: 'Hantera dina kontoinställningar.',
    },
    billing: {
      title: 'Fakturering',
      description: 'Hantera ditt saldo och köp intervjuer.',
    },
    organisation: {
      title: 'Organisation',
      description: 'Hantera organisationsinställningar.',
    },
    team: {
      title: 'Team',
      description: 'Hantera teammedlemmar och behörigheter.',
    },
    interviews: {
      title: 'Intervjurapport',
      description: 'Se kandidatens intervjuresultat och AI-analys.',
    },
    questionBank: {
      title: 'Frågebank',
      description: 'Spara och återanvänd intervjufrågor mellan tjänster.',
    },
    templates: {
      title: 'Jobbmallar',
      description: 'Spara och återanvänd jobbkonfigurationer som mallar.',
    },
    candidates: {
      title: 'Kandidater',
      description: 'Sök och filtrera kandidater över alla tjänster.',
    },
  },
  auth: {
    login: {
      title: 'Fortsätt till Convex SaaS',
      subtitle: 'Välkommen tillbaka! Logga in för att fortsätta.',
      emailLabel: 'E-post',
      emailPlaceholder: 'E-post',
      emailInvalid: 'E-postadressen är inte giltig.',
      continueWithEmail: 'Fortsätt med e-post',
      termsText: 'Genom att klicka på fortsätt godkänner du våra',
      termsOfService: 'Användarvillkor',
      and: 'och',
      privacyPolicy: 'Integritetspolicy.',
      ssoSignIn: 'Logga in med SSO',
      ssoOr: 'eller',
      ssoRedirecting: 'Omdirigerar till din identitetsleverantör…',
      ssoNotConfigured: 'SSO är inte konfigurerat för den här e-postdomänen.',
    },
    verify: {
      title: 'Kolla din inkorg!',
      subtitle:
        'Vi har precis skickat ett tillfälligt lösenord till dig via e-post. Ange det nedan.',
      codePlaceholder: 'Kod',
      codeLabel: 'Kod',
      codeMinLength: 'Koden måste vara minst 8 tecken.',
      continue: 'Fortsätt',
      didNotReceive: 'Fick du ingen kod?',
      requestNewCode: 'Begär ny kod',
      codeSent: 'En ny kod har skickats.',
      invalidCode: 'Ogiltig eller utgången kod.',
    },
  },
  onboarding: {
    username: {
      title: 'Välkommen!',
      subtitle: 'Låt oss börja med att konfigurera din profil.',
      organizationNamePlaceholder: 'Organisationsnamn',
      organizationNameLabel: 'Organisationsnamn',
      firstNamePlaceholder: 'Förnamn',
      firstNameLabel: 'Förnamn',
      lastNamePlaceholder: 'Efternamn',
      lastNameLabel: 'Efternamn',
      usernamePlaceholder: 'Användarnamn',
      usernameLabel: 'Användarnamn',
      continue: 'Fortsätt',
      hint: 'Du kan uppdatera ditt användarnamn när som helst från dina kontoinställningar.',
    },
  },
  jobs: {
    createJob: 'Skapa tjänst',
    noJobs: 'Inga tjänster ännu',
    noJobsDescription: 'Skapa din första tjänst för att komma igång.',
    statusDraft: 'Utkast',
    statusActive: 'Aktiv',
    statusPaused: 'Pausad',
    duplicate: 'Duplicera',
    pause: 'Pausa',
    pauseConfirm: 'Är du säker?',
    delete: 'Ta bort',
    deleteConfirm: 'Är du säker?',
    form: {
      titleLabel: 'Titel',
      titlePlaceholder: 'T.ex. Backend-utvecklare',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholder: 'Beskriv rollen och vad ni söker...',
      languageLabel: 'Intervjuspråk',
      languageSv: 'Svenska',
      languageEn: 'Engelska',
      languageNo: 'Norska',
      languageDa: 'Danska',
      languageFi: 'Finska',
      languageBoth: 'Svenska & Engelska',
      allowedModalitiesLabel: 'Tillåtna modaliteter',
      videoLabel: 'Video',
      videoRequired: 'Obligatorisk',
      videoOptional: 'Valfri',
      videoDisabled: 'Inaktiverad',
      audioLabel: 'Ljud',
      audioRequired: 'Obligatorisk',
      audioDisabled: 'Inaktiverad',
      chatLabel: 'Chatt',
      chatEnabled: 'Aktiverad',
      chatDisabled: 'Inaktiverad',
      expiryDaysLabel: 'Länkens giltighetstid (dagar)',
      interviewCountLabel: 'Antal intervjuer',
      topNLabel: 'Antal toppkandidater att lyfta fram',
      save: 'Spara',
      create: 'Skapa tjänst',
      cancel: 'Avbryt',
    },
    tabs: {
      overview: 'Översikt',
      questions: 'Frågor',
      screener: 'Screener',
      additionalInfo: 'Ytterligare info',
      modality: 'Modalitet',
      voice: 'Röst',
      candidates: 'Kandidater',
      candidateActions: 'Åtgärder',
      report: 'Rapport',
      settings: 'Inställningar',
    },
    overview: {
      name: 'Namn',
      email: 'E-post',
      status: 'Status',
      score: 'Poäng',
      report: 'Rapport',
      noScore: '—',
      viewReport: 'Visa rapport',
      shortlist: 'Shortlist',
      shortlistedOnly: 'Bara shortlistade',
      shareShortlist: 'Dela shortlist',
      copyLink: 'Kopiera länk',
      linkCopied: 'Länk kopierad!',
    },
    shortlist: {
      title: 'Shortlistade kandidater',
      jobLabel: 'Roll',
      name: 'Namn',
      status: 'Status',
      score: 'Poäng',
      noScore: '—',
      empty: 'Inga kandidater har shortlistats ännu.',
    },
    launch: {
      button: 'Lansera tjänst',
      topUpAndLaunch: 'Fyll på & lansera',
      active: 'Aktiv',
      insufficientBalance:
        'Du behöver minst {{required}} SEK för att lansera. Nuvarande saldo: {{balance}} SEK',
    },
    preview: {
      button: 'Förhandsvisa intervju',
      banner: 'Det här är en förhandsvisning — inga krediter dras.',
      loading: 'Skapar förhandsvisning...',
      error: 'Kunde inte starta förhandsvisning. Försök igen.',
      close: 'Stäng',
      completed: 'Förhandsvisning avslutad.',
      screener: {
        title: 'Föranmälningsfrågor',
        continue: 'Fortsätt',
      },
      additionalInfo: {
        title: 'Ytterligare information',
        required: '*',
        continue: 'Fortsätt',
      },
      briefing: {
        aboutToStart: 'Du är på väg att starta en AI-ledd videointervju.',
        expectedDuration: 'Förväntad längd: ungefär {{minutes}} minuter.',
        quietEnvironment:
          'Se till att du befinner dig i en tyst miljö med en fungerande mikrofon.',
        consentText:
          'Jag samtycker till att bli inspelad under denna intervju.',
        termsOfService: 'Användarvillkor',
        privacyPolicy: 'Integritetspolicy',
        starting: 'Startar...',
        ready: 'Jag är redo',
      },
      disqualified: {
        title: 'Tack för ditt intresse',
        body: 'Tyvärr uppfyller du inte kraven för denna tjänst.',
      },
      room: {
        connecting: 'Intervjuaren ansluter...',
      },
    },
    voice: {
      loading: 'Laddar röster...',
      noResults: 'Inga röster matchar dina filter.',
      filterLanguage: 'Språk',
      filterAccent: 'Accent',
      filterCategory: 'Kategori',
      filterGender: 'Kön',
      filterAge: 'Ålder',
    },
    screener: {
      questionPlaceholder: 'T.ex. Har du ett giltigt körkort?',
      optionPlaceholder: 'Alternativ',
      singleSelect: 'Enkelsvar',
      multiChoice: 'Flervalsvar',
      markDisqualifying: 'Markera som diskvalificerande',
      disqualifyingHint:
        'Kryssa i ett alternativ för att diskvalificera kandidater som väljer det.',
      addOption: 'Lägg till alternativ',
      removeOption: 'Ta bort alternativ',
      addQuestion: 'Lägg till fråga',
      remove: 'Ta bort',
      save: 'Spara screener',
      saving: 'Sparar...',
      saved: 'Sparat',
      empty: 'Inga screenerfrågor ännu. Lägg till din första fråga nedan.',
      drag: 'Dra för att ändra ordning',
    },
    additionalInfo: {
      labelPlaceholder: 'T.ex. Portfolio-URL',
      placeholderPlaceholder: 'T.ex. https://...',
      typeText: 'Text',
      typeNumber: 'Nummer',
      typeDate: 'Datum',
      typeUrl: 'URL',
      typeEmail: 'E-post',
      requiredLabel: 'Obligatorisk',
      addField: 'Lägg till fält',
      remove: 'Ta bort',
      save: 'Spara fält',
      saving: 'Sparar...',
      saved: 'Sparat',
      empty: 'Inga fält ännu. Lägg till ditt första fält nedan.',
      drag: 'Dra för att ändra ordning',
    },
    questions: {
      textPlaceholder: 'Skriv din intervjufråga...',
      competencyPlaceholder: 'Kompetens (valfritt)',
      followUpPlaceholder: 'Följdfråga...',
      addQuestion: 'Lägg till fråga',
      addFollowUp: 'Lägg till följdfråga',
      showFollowUps: 'Följdfrågor ({{count}})',
      hideFollowUps: 'Dölj följdfrågor',
      remove: 'Ta bort',
      removeFollowUp: 'Ta bort följdfråga',
      saveToBank: 'Spara till bank',
      addFromBank: 'Lägg till från bank',
      save: 'Spara frågor',
      saving: 'Sparar...',
      saved: 'Sparat',
      empty: 'Inga frågor ännu. Lägg till din första fråga nedan.',
      drag: 'Dra för att ändra ordning',
    },
    locked: {
      notice:
        'Det här kan inte ändras medan tjänsten är aktiv. Pausa tjänsten för att göra ändringar.',
    },
    generate: {
      title: 'Generera med AI',
      tabText: 'Klistra in text',
      tabUrl: 'URL',
      tabPdf: 'PDF',
      textPlaceholder: 'Klistra in en jobbannons här...',
      urlPlaceholder: 'https://example.com/jobbannons',
      pdfLabel: 'Välj PDF',
      pdfSelected: '{{name}}',
      generate: 'Generera',
      generating: 'Genererar...',
      addToJob: 'Lägg till',
      discard: 'Kasta',
      addAll: 'Lägg till alla',
      discardAll: 'Kasta alla',
      error: 'Kunde inte generera frågor. Försök igen.',
    },
    settings: {
      reminderCadenceTitle: 'Påminnelseschema',
      reminderCadenceDescription:
        'Ange vilka dagar efter inbjudan som en påminnelse ska skickas. Lämna tomt för standardschemat (halvvägs, dagen innan, sista dagen).',
      reminderCadenceDefault:
        'Standardschema används (halvvägs, dagen innan, sista dagen).',
      reminderDay: 'Dag {{day}}',
      addReminderDay: 'Lägg till dag',
      removeReminderDay: 'Ta bort påminnelsedag',
      reminderDayPlaceholder: 'Dag (t.ex. 2)',
      competencyWeightsTitle: 'Kompetens­vikter',
      competencyWeightsDescription:
        'Tilldela en relativ vikt för varje kompetens vid beräkning av genomsnittspoängen. Standardvikt är 1 (lika viktning).',
      competencyWeightsNoCompetencies:
        'Inga kompetenser definierade ännu. Lägg till kompetenser i dina intervjufrågor först.',
      competencyWeightsLocked: 'Vikter kan inte ändras när tjänsten är aktiv.',
      introMessageTitle: 'Introbeskrivning',
      introMessageDescription:
        'Visas för kandidater på briefing-skärmen innan intervjun börjar. Lämna tomt för att använda standardtexten.',
      introMessagePlaceholder: 'Lägg till ett personligt intromeddelande…',
      outroMessageTitle: 'Outrobeskrivning',
      outroMessageDescription:
        'Visas för kandidater på slutskärmen efter att intervjun är klar. Lämna tomt för att använda standardtexten.',
      outroMessagePlaceholder: 'Lägg till ett personligt outromed­delande…',
      translationsTitle: 'Översättningar',
      translationsDescription:
        'Lägg till jobbinnehåll på alla intervjuspråk. Använd översättningsknappen för att generera ett utkast, granska och spara sedan.',
      candidateFeedbackTitle: 'Kandidatåterrapportering',
      candidateFeedbackDescription:
        'Visa kandidater deras personliga kompetenspoäng efter avslutad intervju.',
      candidateFeedbackEnabled: 'Visa återrapportering till kandidater',
    },
    translations: {
      generating: 'Genererar…',
      translateFrom: 'Översätt från {{language}}',
      draftHint:
        'AI-utkast — granska och redigera, klicka sedan utanför för att spara.',
      swedish: 'Svenska',
      english: 'Engelska',
    },
  },
  questionBank: {
    addQuestion: 'Lägg till fråga',
    textPlaceholder: 'Skriv din intervjufråga...',
    competencyPlaceholder: 'Kompetens (valfritt)',
    save: 'Spara',
    empty: 'Inga frågor ännu. Lägg till din första fråga nedan.',
    delete: 'Ta bort',
    deleteConfirm: 'Är du säker?',
  },
  interviews: {
    header: {
      title: 'Intervjurapport',
      description: 'Se kandidatens intervjuresultat och AI-analys.',
    },
    candidates: {
      noInterviews: 'Inga intervjuer ännu.',
      statusPending: 'Väntar',
      statusInProgress: 'Pågår',
      statusCompleted: 'Genomförd',
      statusFailed: 'Misslyckades',
      viewReport: 'Visa rapport',
      duration: '{{min}}m {{sec}}s',
      capacity: '{{used}} / {{total}} platser använda',
      increaseCapacity: 'Öka kapacitet',
      increaseCapacityTitle: 'Öka intervjukapacitet',
      increaseCapacityDescription:
        'Varje ytterligare plats kostar {{cost}} krediter. Ditt nuvarande saldo är {{balance}} krediter.',
      additionalSlots: 'Ytterligare platser',
      increaseCapacityConfirm: 'Bekräfta',
      increaseCapacityCancel: 'Avbryt',
      increaseCapacityInsufficientBalance:
        'Otillräckligt saldo. Du behöver {{required}} krediter men har bara {{balance}}.',
    },
    candidateActions: {
      calendlyUrlLabel: 'Calendly-länk',
      calendlyUrlDescription:
        'Klistra in din Calendly-länk för att skicka den till kandidater som vidarebefordras.',
      saveCalendlyUrl: 'Spara',
      noCandidates: 'Inga kandidater ännu.',
      statusInvited: 'Inbjuden',
      statusStarted: 'Påbörjad',
      statusCompleted: 'Genomförd',
      statusExpired: 'Utgången',
      statusDisqualified: 'Diskvalificerad',
      statusRejected: 'Nekad',
      statusAdvanced: 'Vidarebefordrad',
      reject: 'Neka',
      advance: 'Vidarebefordra',
      reTake: 'Tillåt nytt försök',
      rejectDialogTitle: 'Skicka avslagsmail',
      rejectDialogDescription:
        'Detta skickar ett avslagsmail till kandidaten. Du kan lägga till ett valfritt personligt meddelande nedan.',
      rejectCustomMessagePlaceholder: 'Valfritt personligt meddelande...',
      rejectConfirm: 'Skicka avslag',
      advanceConfirmTitle: 'Vidarebefordra kandidat',
      advanceConfirmDescription:
        'Detta skickar en Calendly-länk till kandidaten för att boka en intervju.',
      advanceConfirm: 'Vidarebefordra',
      reTakeConfirmTitle: 'Tillåt nytt försök',
      reTakeConfirmDescription:
        'Detta återställer kandidatens inbjudningslänk och förlänger deadline. Kandidaten får en ny länk.',
      reTakeConfirm: 'Tillåt nytt försök',
      cancel: 'Avbryt',
      selected: '{{count}} valda',
      bulkReject: 'Neka valda',
      bulkAdvance: 'Vidarebefordra valda',
      bulkSendReminder: 'Skicka påminnelse',
      bulkRejectDialogTitle: 'Neka valda kandidater',
      bulkRejectDialogDescription:
        'Detta skickar ett avslagsmail till {{count}} kandidat(er). Du kan lägga till ett valfritt personligt meddelande nedan.',
      bulkRejectConfirm: 'Neka alla',
    },
    report: {
      back: 'Tillbaka till tjänst',
      summary: 'Sammanfattning',
      noSummary: 'Analys pågår...',
      competencies: 'Kompetensbedömning',
      noScores: 'Inga poäng ännu.',
      rationale: 'Motivering',
      quotes: 'Citat',
      noQuotes: 'Inga citat.',
      transcript: 'Transkription',
      noTranscript: 'Ingen transkription tillgänglig.',
      duration: 'Varaktighet',
      completedAt: 'Genomförd',
      shareLabel: 'Dela rapport',
      shareEnabled: 'Delning aktiverad',
      shareDisabled: 'Delning inaktiverad',
      copyLink: 'Kopiera länk',
      linkCopied: 'Kopierad!',
      video: 'Videoinspelning',
      noVideo: 'Ingen videoinspelning tillgänglig.',
      videoLoading: 'Laddar video...',
      clips: 'Kompetensklipp',
      noClips: 'Inga klipp tillgängliga än.',
      clipDuration: '{{sec}}s',
      reviewedBy: 'Granskad av',
      noReviewers: 'Ingen har granskat den här rapporten ännu.',
      notes: 'Anteckningar',
      noNotes: 'Inga anteckningar ännu.',
      addNote: 'Lägg till anteckning',
      notePlaceholder: 'Skriv en anteckning…',
      deleteNote: 'Ta bort',
      noteAdded: 'Anteckning tillagd.',
      aiDetection: 'AI-svarsdetektion',
      aiDetectionPending: 'Analys pågår...',
      aiDetectionLow: 'Svar verkar mänskliga',
      aiDetectionMedium: 'Vissa AI-liknande mönster hittades',
      aiDetectionHigh: 'Svar troligtvis AI-genererade',
      aiDetectionScore: 'Sannolikhetspoäng',
      aiDetectionFlags: 'Flaggade segment',
    },
    chat: {
      title: 'Fråga om kandidaten',
      placeholder: 'Ställ en fråga om kandidatens svar i intervjun...',
      inputPlaceholder: 'Skriv en fråga...',
      send: 'Skicka',
      sending: 'Skickar...',
      errorMessage: 'Ett fel uppstod. Försök igen.',
    },
    orgChat: {
      title: 'Fråga om kandidater',
      placeholder: 'Ställ en fråga om valfri kandidat i alla tjänster...',
      inputPlaceholder: 'T.ex. Vem fick högst poäng i problemlösning?',
      send: 'Skicka',
      sending: 'Skickar...',
      errorMessage: 'Ett fel uppstod. Försök igen.',
      toggle: 'AI-chatt',
    },
    publicReport: {
      notFound: 'Denna rapport är inte längre tillgänglig.',
      notFoundDescription:
        'Länken kan ha gått ut eller delning har inaktiverats.',
    },
    pdfExport: {
      downloadButton: 'Ladda ned',
      aggregatedReport: 'Ladda ned samlad rapport',
      transcripts: 'Ladda ned transskript',
      individualReports: 'Ladda ned individuella rapporter',
      drawerTitleTranscripts: 'Ladda ned transskript',
      drawerTitleReports: 'Ladda ned individuella rapporter',
      drawerDescription: 'Välj kandidater att inkludera i nedladdningen.',
      selectAll: 'Välj alla',
      deselectAll: 'Avmarkera alla',
      downloadSelected: 'Ladda ned valda',
      downloadAll: 'Ladda ned alla',
      generating: 'Genererar {{completed}} av {{total}}...',
      complete: 'Nedladdning klar',
      error: 'Export misslyckades. Försök igen.',
      noCompletedCandidates: 'Inga genomförda intervjuer att exportera.',
      cancel: 'Avbryt',
    },
    aggregateReport: {
      noCompletedInterviews: 'Inga genomförda intervjuer ännu.',
      rank: 'Rankning',
      candidate: 'Kandidat',
      averageScore: 'Medelpoäng',
      topN: 'Topp {{n}}',
      competencies: 'Kompetensuppdelning',
    },
    candidateFeedback: {
      title: 'Dina resultat',
      preparing: 'Din personliga återrapportering förbereds…',
      competencies: 'Kompetenspoäng',
      scoreLabel: '{{score}} / 10',
    },
  },
  candidateSearch: {
    searchPlaceholder: 'Sök på namn eller e-post…',
    filterJob: 'Alla tjänster',
    filterStatus: 'Alla statusar',
    filterMinScore: 'Minpoäng',
    filterMaxScore: 'Maxpoäng',
    filterFromDate: 'Från datum',
    filterToDate: 'Till datum',
    clearFilters: 'Rensa filter',
    noResults: 'Inga kandidater hittades.',
    columnName: 'Namn',
    columnJob: 'Tjänst',
    columnStatus: 'Status',
    columnScore: 'Medelpoäng',
    columnDate: 'Inbjuden',
    viewReport: 'Visa rapport',
    scoreValue: '{{score}}',
    noScore: '—',
  },
  notifications: {
    title: 'Notiser',
    markAllRead: 'Markera alla som lästa',
    empty: 'Inga notiser ännu.',
    typeInterviewCompleted: 'Intervju genomförd',
    typeInterviewFailed: 'Intervju misslyckades',
    typeLowBalance: 'Lågt saldo',
    typeJobActivated: 'Tjänst aktiverad',
    typeCandidateExpired: 'Kandidat utgången',
  },
  dashboard: {
    getStarted: 'Kom igång',
    getStartedDescription:
      'Utforska instrumentpanelen och kom igång med din första app.',
    tipChangeLanguage: 'TIPS: Prova att byta språk!',
    exploreDocumentation: 'Utforska dokumentationen',
    statsInvited: 'Inbjudna',
    statsCompleted: 'Slutförda',
    statsAdvanced: 'Avancerade',
    statsAvgScore: 'Genomsnittlig poäng',
    analytics: {
      title: 'Analys',
      jobTitle: 'Tjänst',
      status: 'Status',
      completionRate: 'Slutförandegrad',
    },
    accountLocked: {
      message:
        'Din prenumeration har upphört. Återaktivera för att fortsätta köra intervjuer.',
      reactivate: 'Återaktivera',
    },
  },
  settings: {
    avatar: {
      title: 'Din avatar',
      description: 'Det här är din avatar. Den visas på din profil.',
      hint: 'Klicka på avataren för att ladda upp en egen från dina filer.',
      reset: 'Återställ',
    },
    profile: {
      title: 'Din profil',
      description: 'Ditt för- och efternamn visas för kandidater och kollegor.',
      firstNamePlaceholder: 'Förnamn',
      lastNamePlaceholder: 'Efternamn',
      hint: 'Använd ditt riktiga namn.',
      save: 'Spara',
    },
    username: {
      title: 'Ditt användarnamn',
      description: 'Det här är ditt användarnamn. Det visas på din profil.',
      placeholder: 'Användarnamn',
      hint: 'Använd maximalt 32 tecken.',
      save: 'Spara',
    },
    deleteAccount: {
      title: 'Radera konto',
      description:
        'Radera ditt konto permanent, alla dina projekt och all relaterad data.',
      hint: 'Den här åtgärden kan inte ångras, fortsätt med försiktighet.',
      confirm: 'Är du säker?',
      delete: 'Radera konto',
    },
    contactSupport: {
      title: 'Kontakta support',
      description:
        'Rapportera ett fel, ställ en fråga eller begär en funktion.',
      topicLabel: 'Ämne',
      topicBug: 'Bugg',
      topicTechnicalIssue: 'Tekniskt problem',
      topicBilling: 'Fakturering',
      topicGeneral: 'Allmän fråga',
      topicFeatureRequest: 'Funktionsförfrågan',
      severityLabel: 'Allvarlighetsgrad',
      severityLow: 'Låg',
      severityMedium: 'Medium',
      severityHigh: 'Hög',
      severityCritical: 'Kritisk',
      subjectLabel: 'Rubrik',
      subjectPlaceholder: 'Kort beskrivning av problemet',
      messageLabel: 'Meddelande',
      messagePlaceholder: 'Beskriv ditt problem i detalj…',
      submit: 'Skicka',
      submitting: 'Skickar…',
      successTitle: 'Förfrågan mottagen',
      successMessage: 'Din biljett har skickats. Referens: {{ticketId}}',
      hint: 'Vi återkommer så snart som möjligt.',
    },
    tabs: {
      general: 'Allmänt',
      billing: 'Fakturering',
      organisation: 'Organisation',
      branding: 'Varumärke',
      team: 'Team',
      notifications: 'Notifikationer',
    },
    branding: {
      title: 'Varumärke',
      description: 'Anpassa hur din organisation visas för kandidater.',
      logoTitle: 'Logotyp',
      logoDescription: 'Visas på kandidatens intervjuinformationsskärm.',
      uploadLogo: 'Ladda upp logotyp',
      uploading: 'Laddar upp...',
      primaryColorTitle: 'Primärfärg',
      primaryColorDescription:
        'Används på knappar och accenter i kandidatflödet.',
      websiteTitle: 'Webbplats',
      websiteDescription:
        'Visas för kandidater som en länk för att lära sig mer om ditt företag.',
      taglineTitle: 'Slogan',
      taglineDescription:
        'En kort beskrivning av ditt företag som visas på informationsskärmen.',
      taglinePlaceholder: 'T.ex. Vi bygger framtidens arbete',
      hint: 'Dessa inställningar är synliga för kandidater.',
      save: 'Spara',
      saving: 'Sparar...',
      saved: 'Sparat',
    },
    notifications: {
      title: 'Notifikationsinställningar',
      description: 'Välj vilka e-postnotifikationer du vill ta emot.',
      lowBalanceLabel: 'Lågt saldo',
      lowBalanceDescription:
        'Få ett e-postmeddelande när ditt saldo sjunker till 5 eller färre intervjuer.',
      interviewCompletedLabel: 'Intervju genomförd',
      interviewCompletedDescription:
        'Få ett e-postmeddelande när en kandidat genomför sin intervju.',
      reportReadyLabel: 'Rapport klar',
      reportReadyDescription:
        'Få ett e-postmeddelande när AI-analysen för en intervju är klar.',
      teamMemberJoinedLabel: 'Teammedlem gick med',
      teamMemberJoinedDescription:
        'Få ett e-postmeddelande när en ny teammedlem går med i din organisation.',
    },
    team: {
      title: 'Teammedlemmar',
      description: 'Hantera ditt teams åtkomst till organisationen.',
      inviteTitle: 'Bjud in teammedlem',
      inviteDescription: 'Skicka en inbjudan via e-post.',
      emailLabel: 'E-post',
      emailPlaceholder: 'kollega@exempel.se',
      roleLabel: 'Roll',
      roleMember: 'Medlem',
      roleAdmin: 'Admin',
      roleOwner: 'Ägare',
      invite: 'Bjud in',
      inviteSent: 'Inbjudan skickad.',
      membersTitle: 'Nuvarande medlemmar',
      remove: 'Ta bort',
      removeDialogTitle: 'Ta bort teammedlem',
      removeDialogDescription:
        'Är du säker på att du vill ta bort {{name}} från organisationen?',
      removeConfirm: 'Ta bort',
      cancel: 'Avbryt',
      hint: 'Inbjudna användare får tillgång till organisationens resurser.',
    },
    organisation: {
      title: 'Organisationsinställningar',
      description: 'Inställningar som visas för kandidater.',
      displayNameTitle: 'Visningsnamn',
      displayNameDescription:
        'Det här namnet visas för kandidater i intervjuportalen.',
      displayNamePlaceholder: 'Organisationsnamn',
      termsUrlTitle: 'Länk till användarvillkor',
      termsUrlDescription: 'Visas för kandidater vid intervjuinbjudan.',
      termsUrlPlaceholder: 'https://example.com/terms',
      privacyUrlTitle: 'Länk till integritetspolicy',
      privacyUrlDescription: 'Visas för kandidater vid intervjuinbjudan.',
      privacyUrlPlaceholder: 'https://example.com/privacy',
      hint: 'Dessa inställningar visas för kandidater.',
      save: 'Spara',
      sso: {
        title: 'Enkel inloggning (SSO)',
        description:
          'Låt teammedlemmar logga in med organisationens identitetsleverantör.',
        emailDomainTitle: 'E-postdomän',
        emailDomainDescription:
          'E-postdomänen som används för att identifiera SSO-användare (t.ex. foretag.se).',
        emailDomainPlaceholder: 'foretag.se',
        discoveryUrlTitle: 'OIDC Discovery-URL',
        discoveryUrlDescription:
          'URL:en för OpenID Connect-konfigurationen hos din identitetsleverantör.',
        discoveryUrlPlaceholder:
          'https://din-idp.example.com/.well-known/openid-configuration',
        clientIdTitle: 'Klient-ID',
        clientIdDescription:
          'Klient-ID:t som registrerats hos identitetsleverantören.',
        clientIdPlaceholder: 'klient-id',
        clientSecretTitle: 'Klienthemlighet',
        clientSecretDescription:
          'Klienthemligheten som registrerats hos identitetsleverantören.',
        clientSecretPlaceholder: '••••••••',
        clientSecretSetOn: 'Inställd den {{date}}',
        clientSecretRotate: 'Rotera',
        clientSecretRemove: 'Ta bort',
        saveConfig: 'Spara SSO-konfiguration',
        enforceTitle: 'Kräv SSO',
        enforceDescription:
          'Kräv att teammedlemmar loggar in via SSO. Organisationsägare är alltid undantagna.',
        enforced: 'Aktiverat',
        notEnforced: 'Ej aktiverat',
        hint: 'SSO-konfigurationen visas endast för organisationsägare.',
      },
    },
  },
  support: {
    contactForm: {
      nameLabel: 'Namn',
      namePlaceholder: 'Ditt namn',
      emailLabel: 'E-post',
      emailPlaceholder: 'din@epost.se',
      successTitle: 'Meddelande skickat',
      successMessage:
        'Vi har tagit emot ditt meddelande och återkommer så snart som möjligt.',
      errorGeneric: 'Något gick fel. Försök igen.',
    },
  },
  billing: {
    balanceTitle: 'Ditt saldo',
    balanceDescription: 'Tillgängligt saldo för intervjuer.',
    subscriptionTitle: 'Prenumeration',
    subscriptionDescription:
      'Starta din 14-dagars gratis provperiod. Ingen avgift förrän provperioden är slut.',
    subscriptionNote:
      'Du omdirigeras till Polar för att slutföra registreringen.',
    subscriptionStatusActive: 'Aktiv',
    subscriptionStatusTrialing: 'Provperiod',
    subscribeLabel: 'Starta gratis provperiod',
    manageSubscription: 'Hantera prenumeration',
    trialEndsOn: 'Provperioden avslutas {{date}}',
    topUpTitle: 'Fyll på saldo',
    topUpDescription: 'Välj ett belopp för att fylla på ditt konto.',
    topUpNote: 'Du omdirigeras till Polar för betalning.',
    topUpLabel: 'Fyll på',
    invoiceHistoryTitle: 'Fakturahistorik',
    invoiceHistoryDescription: 'Se dina tidigare köp och fakturor.',
    redirectedToPolar: 'Du omdirigeras till Polar kundportal.',
    viewInvoices: 'Visa fakturor',
    billingEmailTitle: 'Fakturaadress',
    billingEmailDescription:
      'Kvitton och fakturor från Polar skickas till denna adress.',
    billingEmailPlaceholder: 'faktura@exempel.se',
    billingEmailSave: 'Spara',
    billingEmailSaved: 'Sparat.',
    billingEmailHint:
      'Lämna tomt för att använda kontots e-postadress. Endast admins och ägare kan ändra detta.',
    autoTopUpTitle: 'Automatisk påfyllning',
    autoTopUpDescription:
      'Fyll automatiskt på ditt saldo när det understiger ett tröskelvärde.',
    autoTopUpEnabled: 'Aktiverad',
    autoTopUpDisabled: 'Inaktiverad',
    autoTopUpNoPaymentMethod:
      'Ingen sparad betalningsmetod. Genomför ett köp först för att aktivera automatisk påfyllning.',
    autoTopUpThresholdLabel: 'Fyll på när färre än',
    autoTopUpThresholdUnit: 'intervjuer återstår',
    autoTopUpProductLabel: 'Påfyllningspaket',
    autoTopUpSave: 'Spara',
    autoTopUpSaved: 'Sparat.',
  },
  checkout: {
    title: 'Betalning genomförd',
    description: 'Din betalning har genomförts och ditt saldo har uppdaterats.',
    completed: 'Köpet slutfört!',
    returnToDashboard: 'Återgå till instrumentpanelen',
  },
  templates: {
    empty: 'Inga mallar ännu',
    emptyDescription:
      'Spara ett befintligt jobb som mall för att återanvända det.',
    questionCount: 'Frågor',
    screenerCount: 'Screener',
    interviewCount: 'Intervjuer',
    useTemplate: 'Använd mall',
    saveAsTemplate: 'Spara som mall',
    saveAsTemplateTitle: 'Spara som mall',
    templateNameLabel: 'Mallnamn',
    templateNamePlaceholder: 'T.ex. Senior Backend-utveck­lare',
    saveButton: 'Spara',
    createFromTemplateTitle: 'Skapa tjänst från "{{name}}"',
    createJobButton: 'Skapa tjänst',
  },
  candidate: {
    loading: 'Laddar…',
    invalid: {
      title: 'Länken är ogiltig',
      body: 'Den här inbjudningslänken har gått ut eller är inte längre giltig.',
    },
    orgLocked: {
      title: 'Kontot inaktivt',
      body: 'Den här organisationens konto är för närvarande inaktivt. Kontakta rekryteraren för hjälp.',
    },
    disqualified: {
      title: 'Tack för ditt intresse',
      body: 'Tyvärr uppfyller du inte kraven för denna tjänst.',
    },
    screener: {
      title: 'Föranmälningsfrågor',
      continue: 'Fortsätt',
    },
    additionalInfo: {
      title: 'Ytterligare information',
      continue: 'Fortsätt',
    },
    briefing: {
      howToConduct: 'Hur vill du genomföra intervjun?',
      usesModality: 'Den här intervjun använder',
      aboutToStart: 'Du är på väg att starta en AI-ledd intervju.',
      expectedDuration: 'Förväntad längd: ungefär {{minutes}} minuter.',
      quietEnvironment:
        'Se till att du befinner dig i en tyst miljö med en fungerande mikrofon.',
      aiNotice:
        'Dina svar bedöms av ett AI-system. En mänsklig rekryterare granskar alla AI-genererade resultat och fattar varje anställningsbeslut självständigt – inget automatiserat beslut fattas om din ansökan.',
      requestScores:
        'Du kan när som helst begära dina kompetenspoäng och motiveringar via e-post till',
      consentRecording:
        'Jag samtycker till att bli inspelad under denna intervju.',
      consentAi:
        'Jag samtycker till att mina svar behandlas av AI under denna intervju.',
      termsOfService: 'Användarvillkor',
      privacyPolicy: 'Integritetspolicy',
      starting: 'Startar…',
      ready: 'Jag är redo',
      insufficientBalance:
        'Intervjun kunde inte startas just nu. Kontakta rekryteraren.',
      orgLockedError:
        'Den här organisationens konto är för närvarande inaktivt. Kontakta rekryteraren.',
    },
    modality: {
      video: { label: 'Video', description: 'Kamera och mikrofon' },
      audio: { label: 'Endast ljud', description: 'Mikrofon' },
      chat: { label: 'Text', description: 'Skriftliga svar' },
    },
    room: {
      connecting: 'Intervjuaren ansluter…',
      questionOf: 'Fråga {{index}} av {{total}}',
      answered: '{{completed}} av {{total}} besvarade',
      chatPlaceholder: 'Skriv ditt svar…',
      chatSend: 'Skicka',
      chatLeave: 'Lämna',
    },
    completed: {
      title: 'Intervjun är klar',
      defaultOutro: 'Tack för din tid. Vi återkommer snart.',
      feedbackQuestion: 'Hur var din upplevelse?',
      feedbackComment: 'Ytterligare kommentarer? (valfritt)',
      feedbackSubmit: 'Skicka feedback',
      feedbackThanks: 'Tack för din feedback.',
    },
    abandoned: {
      title: 'Intervjun avslutad',
      body: 'Du har lämnat intervjun. Om det var avsiktligt behöver du inte göra något mer.',
    },
    error: {
      title: 'Något gick fel',
      body: 'Ett oväntat fel uppstod under din intervju. Försök igen eller kontakta support.',
      reportLink: 'Rapportera ett tekniskt problem',
      severityTitle: 'Hur allvarligt var problemet?',
      severityLow: 'Mindre – jag kunde fortsätta',
      severityMedium: 'Betydande – intervjun stördes',
      severityHigh: 'Kritiskt – jag kunde inte slutföra intervjun',
      describeTitle: 'Beskriv vad som hände',
      describePlaceholder: 'T.ex. Ljudet slutade fungera, sidan frös…',
      submit: 'Skicka rapport',
      submitting: 'Skickar…',
      submitted: 'Din rapport har skickats. Tack.',
    },
  },
  ai: {
    generate: 'Generera',
  },
} as const

export default sv
